import { render, staticRenderFns } from "./SororityWarsFightWeeklyMM.vue?vue&type=template&id=4f5b9e6c&scoped=true&"
import script from "./SororityWarsFightWeeklyMM.vue?vue&type=script&lang=js&"
export * from "./SororityWarsFightWeeklyMM.vue?vue&type=script&lang=js&"
import style0 from "./SororityWarsFightWeeklyMM.vue?vue&type=style&index=0&id=4f5b9e6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b9e6c",
  null
  
)

export default component.exports